module.exports = __webpack_public_path__ + "static/media/sura.aa1fc564.png";